$(document).on('show.bs.collapse', ".collapse", function () {
	$(this).prev(".item-header").addClass("active");
}).on('hide.bs.collapse', ".collapse", function () {
	$(this).prev(".item-header").removeClass("active");
}); 